import container from '@/container';
import { UserState, CultureState } from '@/store';
import { StringsServiceContract, CONTRACTS, EventsServiceContract } from './core/contracts';

export async function startupServicesAsync(): Promise<void> {
    await CultureState.ensureLoaded();
    await UserState.fetchUser();

    const strings = container.get<StringsServiceContract>(CONTRACTS.StringsService);
    await strings.startupAsync();

    const events = container.get<EventsServiceContract>(CONTRACTS.EventsService);
    await events.startupAsync();
}
